import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { State } from "../../store/state";
import {
  Grid,
  Typography,
  FormControl,
  TextField,
  MenuItem,
  FormControlLabel,
  RadioGroup,
  Radio,
  Tooltip,
  IconButton,
  Divider,
} from "@material-ui/core";
import { DeleteOutline as DeleteOutlineIcon } from "@material-ui/icons";
import {
  fromIssues,
  toIssues,
  plasticMessageIssues,
  printerMessageIssues,
  emailMessageIssues,
  nameIssues,
  companyIssues,
  addressIssues,
  cityIssues,
  stateIssues,
  zipIssues,
  emailIssues,
} from "../../store/validators";
import * as consts from "../../consts";
import MUIRichTextEditor from "mui-rte";

export default function CardMessage(props) {
  const { state, dispatch } = useContext(State);

  const renderFromInput = (row, index, validate, onChange) => {
    let error = fromIssues(row.from, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        fullWidth={true}
        label="From"
        error={error ? true : false}
        helperText={error ? error : ""}
        variant="outlined"
        value={row.from}
        onChange={onChange}
      />
    );
  };

  const renderToInput = (row, index, validate, onChange) => {
    let error = toIssues(row.to, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        variant="outlined"
        fullWidth={true}
        label="To"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.to}
        onChange={onChange}
      />
    );
  };

  const renderMessageInput = (row, index, validate, cardType, onChange) => {
    switch (cardType) {
      case consts.CARD_TYPE_PLASTIC:
        return renderPlasticMessageInput(row, index, validate, onChange);
      case consts.CARD_TYPE_EMAIL:
        return renderEmailMessageInput(row, index, validate, onChange);
      case consts.CARD_TYPE_PRINTER:
        return renderPrinterMessageInput(row, index, validate, onChange);
      default:
        return null;
    }
  };

  const renderPlasticMessageInput = (row, index, validate, onChange) => {
    let error = plasticMessageIssues(row.message, validate);
    return (
      <React.Fragment>
        <span
          className={props.classes.cardmessagelimit}
        >{`${row.message.length}/550`}</span>
        <TextField
          className={props.classes.cardmessageinput}
          fullWidth={true}
          multiline={true}
          rows={5}
          variant="outlined"
          label="Message"
          error={error ? true : false}
          helperText={error ? error : ""}
          value={row.message}
          onChange={onChange}
        />
      </React.Fragment>
    );
  };

  const renderPrinterMessageInput = (row, index, validate, onChange) => {
    let error = printerMessageIssues(row.message, validate);
    return (
      <React.Fragment>
        <span
          className={props.classes.cardmessagelimit}
        >{`${row.message.length}/550`}</span>
        {/* <MUIRichTextEditor
          label="Message"
          fullWidth={true}
          multiline={true}
          rows={5}
          variant="outlined"
          error={error ? true : false}
          helperText={error ? error : ""}
          value={row.message}
          onChange={onChange}
        /> */}

        <TextField
          className={props.classes.cardmessageinput}
          fullWidth={true}
          multiline={true}
          rows={5}
          variant="outlined"
          label="Message"
          error={error ? true : false}
          helperText={error ? error : ""}
          value={row.message}
          onChange={onChange}
        />
      </React.Fragment>
    );
  };

  const renderEmailMessageInput = (row, index, validate, onChange) => {
    let error = emailMessageIssues(row.message, validate);
    return (
      <React.Fragment>
        <span
          className={props.classes.cardmessagelimit}
        >{`${row.message.length}/900`}</span>
        <TextField
          className={props.classes.cardmessageinput}
          fullWidth={true}
          multiline={true}
          rows={5}
          variant="outlined"
          label="Message"
          error={error ? true : false}
          helperText={error ? error : ""}
          value={row.message}
          onChange={onChange}
        />
      </React.Fragment>
    );
  };

  const renderNameInput = (row, index, validate, onChange) => {
    let error = nameIssues(row.shipping.name, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        autoComplete={`shipping${index} name`}
        required={true}
        fullWidth={true}
        variant="outlined"
        label="Name"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.shipping.name}
        onChange={onChange}
      />
    );
  };

  const renderCompanyInput = (row, index, validate, onChange) => {
    let error = companyIssues(row.shipping.company, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        autoComplete={`shipping${index} company`}
        fullWidth={true}
        variant="outlined"
        label="Company"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.shipping.company}
        onChange={onChange}
      />
    );
  };

  const renderAddressInput = (row, index, validate, onChange) => {
    let error = addressIssues(row.shipping.address, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        autoComplete={`shipping${index} street-address`}
        required={true}
        fullWidth={true}
        variant="outlined"
        label="Address"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.shipping.address}
        onChange={onChange}
      />
    );
  };

  const renderCityInput = (row, index, validate, onChange) => {
    let error = cityIssues(row.shipping.city, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        autoComplete={`shipping${index} address-level2`}
        required={true}
        fullWidth={true}
        variant="outlined"
        label="City"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.shipping.city}
        onChange={onChange}
      />
    );
  };

  const renderStateInput = (row, index, validate, onChange) => {
    let error = stateIssues(row.shipping.state, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        autoComplete={`shipping${index} region`}
        required={true}
        fullWidth={true}
        variant="outlined"
        label="State"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.shipping.state}
        onChange={onChange}
        select={true}
      >
        <MenuItem value="*">SELECT STATE</MenuItem>
        {consts.STATES.map((state) => {
          return (
            <MenuItem key={state.abbreviation} value={state.abbreviation}>
              {state.name}
            </MenuItem>
          );
        })}
      </TextField>
    );
  };

  const renderZipInput = (row, index, validate, onChange) => {
    let error = zipIssues(row.shipping.zip, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        autoComplete={`shipping${index} postal-code`}
        required={true}
        fullWidth={true}
        variant="outlined"
        label="Zip"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.shipping.zip}
        onChange={onChange}
      />
    );
  };

  const renderEmailInput = (row, index, validate, onChange) => {
    let error = emailIssues(row.email, validate);
    return (
      <TextField
        className={props.classes.cardmessageinput}
        required={true}
        fullWidth={true}
        variant="outlined"
        label="Email"
        error={error ? true : false}
        helperText={error ? error : ""}
        value={row.email}
        onChange={onChange}
      />
    );
  };

  const renderSynchronizeOption = () => {
    return (
      <Grid
        item
        container
        xs={12}
        spacing={2}
        className={props.classes.cardmessagesynchronizeOption}
      >
        <FormControl>
          <RadioGroup
            value={props.synchronize}
            onChange={(event) => {
              props.onSynchronizeChanged(event.target.value);
            }}
          >
            <FormControlLabel
              value={consts.SYNCHRONIZE_YES}
              control={<Radio />}
              label="Include the same From &amp; Message"
            />
            <FormControlLabel
              value={consts.SYNCHRONIZE_NO}
              control={<Radio />}
              label="Use different From &amp; Message"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    );
  };

  const renderGlobalInputs = (
    cardDetails,
    validate,
    cardType,
    onCardDetailsChanged
  ) => {
    return (
      <Grid
        item
        container
        xs={12}
        spacing={2}
        className={props.classes.cardmessageglobal}
      >
        <Grid item xs={12}>
          {renderFromInput(cardDetails[0], "", validate, (event) => {
            let updatedCardDetails = [...cardDetails];
            updatedCardDetails = updatedCardDetails.map((cardDetail) => {
              return {
                ...cardDetail,
                from: event.target.value,
              };
            });
            onCardDetailsChanged(updatedCardDetails);
          })}
        </Grid>
        <Grid item xs={12}>
          {renderMessageInput(
            cardDetails[0],
            "",
            validate,
            cardType,
            (event) => {
              let updatedCardDetails = [...cardDetails];
              updatedCardDetails = updatedCardDetails.map((cardDetail) => {
                return {
                  ...cardDetail,
                  message: event.target.value,
                };
              });
              onCardDetailsChanged(updatedCardDetails);
            }
          )}
        </Grid>
      </Grid>
    );
  };

  const renderRows = (
    cardDetails,
    cardType,
    mailOption,
    synchronizeInputs,
    validate,
    onCardDetailsChanged
  ) => {
    return (
      <Grid item container xs={12} className={props.classes.cardmessagerows}>
        {cardDetails.map((row, index) => {
          return (
            <Grid
              item
              container
              xs={12}
              key={index}
              className={props.classes.cardmessagerow}
            >
              {cardDetails.length > 1 && (
                <Grid
                  item
                  container
                  xs={12}
                  className={props.classes.cardmessagedivider}
                >
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={11}>
                    <Typography
                      variant="body1"
                      component="div"
                      align="left"
                      className={props.classes.cardmessagecardNumber}
                    >
                      Card #{index + 1}
                    </Typography>
                  </Grid>
                  <Grid item xs={1} className={props.classes.cardmessageremove}>
                    <Tooltip title="Remove Card">
                      <IconButton
                        aria-label="Remove Card"
                        onClick={() => {
                          props.onRemoveCard(index);
                        }}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              )}
              <Grid item container xs={12}>
                <Grid container item xs={12} spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body1" component="div" align="left">
                      Personalize
                    </Typography>
                  </Grid>
                  {!synchronizeInputs && (
                    <Grid item xs={12} sm={6}>
                      {renderFromInput(row, index, validate, (event) => {
                        let updatedCardDetails = [...cardDetails];
                        updatedCardDetails[index] = {
                          ...cardDetails[index],
                          from: event.target.value,
                        };
                        onCardDetailsChanged(updatedCardDetails);
                      })}
                    </Grid>
                  )}
                  <Grid item xs={12} sm={synchronizeInputs ? 12 : 6}>
                    {renderToInput(row, index, validate, (event) => {
                      let updatedCardDetails = [...cardDetails];
                      updatedCardDetails[index] = {
                        ...cardDetails[index],
                        to: event.target.value,
                      };
                      onCardDetailsChanged(updatedCardDetails);
                    })}
                  </Grid>
                  {!synchronizeInputs && (
                    <Grid item xs={12}>
                      {renderMessageInput(
                        row,
                        index,
                        validate,
                        cardType,
                        (event) => {
                          let updatedCardDetails = [...cardDetails];
                          updatedCardDetails[index] = {
                            ...cardDetails[index],
                            message: event.target.value,
                          };
                          onCardDetailsChanged(updatedCardDetails);
                        }
                      )}
                    </Grid>
                  )}
                </Grid>
                <Grid container item xs={12} spacing={2}>
                  {((cardType == consts.CARD_TYPE_PLASTIC &&
                    mailOption == consts.PLASTIC_TYPE_THEM) ||
                    cardType == consts.CARD_TYPE_EMAIL) && (
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        component="div"
                        align="left"
                        className={props.classes.cardmessagesendto}
                      >
                        Send To
                      </Typography>
                    </Grid>
                  )}
                  {cardType == consts.CARD_TYPE_PLASTIC &&
                    mailOption == consts.PLASTIC_TYPE_THEM && (
                      <Grid item xs={12} md={6}>
                        {renderNameInput(row, index, validate, (event) => {
                          let updatedCardDetails = [...cardDetails];
                          updatedCardDetails[index] = {
                            ...cardDetails[index],
                            shipping: {
                              ...cardDetails[index].shipping,
                              name: event.target.value,
                            },
                          };
                          onCardDetailsChanged(updatedCardDetails);
                        })}
                      </Grid>
                    )}
                  {cardType == consts.CARD_TYPE_PLASTIC &&
                    mailOption == consts.PLASTIC_TYPE_THEM && (
                      <Grid item xs={12} md={6}>
                        {renderCompanyInput(row, index, validate, (event) => {
                          let updatedCardDetails = [...cardDetails];
                          updatedCardDetails[index] = {
                            ...cardDetails[index],
                            shipping: {
                              ...cardDetails[index].shipping,
                              company: event.target.value,
                            },
                          };
                          onCardDetailsChanged(updatedCardDetails);
                        })}
                      </Grid>
                    )}
                  {cardType == consts.CARD_TYPE_PLASTIC &&
                    mailOption == consts.PLASTIC_TYPE_THEM && (
                      <Grid item xs={12} md={6}>
                        {renderAddressInput(row, index, validate, (event) => {
                          let updatedCardDetails = [...cardDetails];
                          updatedCardDetails[index] = {
                            ...cardDetails[index],
                            shipping: {
                              ...cardDetails[index].shipping,
                              address: event.target.value,
                            },
                          };
                          onCardDetailsChanged(updatedCardDetails);
                        })}
                      </Grid>
                    )}
                  {cardType == consts.CARD_TYPE_PLASTIC &&
                    mailOption == consts.PLASTIC_TYPE_THEM && (
                      <Grid item xs={12} md={6}>
                        {renderCityInput(row, index, validate, (event) => {
                          let updatedCardDetails = [...cardDetails];
                          updatedCardDetails[index] = {
                            ...cardDetails[index],
                            shipping: {
                              ...cardDetails[index].shipping,
                              city: event.target.value,
                            },
                          };
                          onCardDetailsChanged(updatedCardDetails);
                        })}
                      </Grid>
                    )}
                  {cardType == consts.CARD_TYPE_PLASTIC &&
                    mailOption == consts.PLASTIC_TYPE_THEM && (
                      <Grid item xs={12} md={6}>
                        {renderStateInput(row, index, validate, (event) => {
                          let updatedCardDetails = [...cardDetails];
                          updatedCardDetails[index] = {
                            ...cardDetails[index],
                            shipping: {
                              ...cardDetails[index].shipping,
                              state: event.target.value,
                            },
                          };
                          onCardDetailsChanged(updatedCardDetails);
                        })}
                      </Grid>
                    )}
                  {cardType == consts.CARD_TYPE_PLASTIC &&
                    mailOption == consts.PLASTIC_TYPE_THEM && (
                      <Grid item xs={12} md={6}>
                        {renderZipInput(row, index, validate, (event) => {
                          let updatedCardDetails = [...cardDetails];
                          updatedCardDetails[index] = {
                            ...cardDetails[index],
                            shipping: {
                              ...cardDetails[index].shipping,
                              zip: event.target.value,
                            },
                          };
                          onCardDetailsChanged(updatedCardDetails);
                        })}
                      </Grid>
                    )}
                  {cardType == consts.CARD_TYPE_EMAIL && (
                    <Grid item xs={12}>
                      {renderEmailInput(row, index, validate, (event) => {
                        let updatedCardDetails = [...cardDetails];
                        updatedCardDetails[index] = {
                          ...cardDetails[index],
                          email: event.target.value,
                        };
                        onCardDetailsChanged(updatedCardDetails);
                      })}
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const renderDelivery = (
    cardDetails,
    cardType,
    mailOption,
    validate,
    onCardDetailsChanged
  ) => {
    return (
      <Grid
        item
        container
        xs={12}
        spacing={2}
        className={props.classes.cardmessagedelivery}
      >
        {cardType == consts.CARD_TYPE_PLASTIC &&
          mailOption == consts.PLASTIC_TYPE_ME && (
            <Grid item xs={12}>
              <Typography
                variant="body1"
                component="div"
                align="left"
                className={props.classes.cardmessagesendto}
              >
                Send To
              </Typography>
            </Grid>
          )}
        {cardType == consts.CARD_TYPE_PLASTIC &&
          mailOption == consts.PLASTIC_TYPE_ME && (
            <Grid item xs={12} md={6}>
              {renderNameInput(cardDetails[0], "", validate, (event) => {
                let updatedCardDetails = [...cardDetails];
                updatedCardDetails = updatedCardDetails.map((cardDetail) => {
                  return {
                    ...cardDetail,
                    shipping: {
                      ...cardDetail.shipping,
                      name: event.target.value,
                    },
                  };
                });
                onCardDetailsChanged(updatedCardDetails);
              })}
            </Grid>
          )}
        {cardType == consts.CARD_TYPE_PLASTIC &&
          mailOption == consts.PLASTIC_TYPE_ME && (
            <Grid item xs={12} md={6}>
              {renderCompanyInput(cardDetails[0], "", validate, (event) => {
                let updatedCardDetails = [...cardDetails];
                updatedCardDetails = updatedCardDetails.map((cardDetail) => {
                  return {
                    ...cardDetail,
                    shipping: {
                      ...cardDetail.shipping,
                      company: event.target.value,
                    },
                  };
                });
                onCardDetailsChanged(updatedCardDetails);
              })}
            </Grid>
          )}
        {cardType == consts.CARD_TYPE_PLASTIC &&
          mailOption == consts.PLASTIC_TYPE_ME && (
            <Grid item xs={12} md={6}>
              {renderAddressInput(cardDetails[0], "", validate, (event) => {
                let updatedCardDetails = [...cardDetails];
                updatedCardDetails = updatedCardDetails.map((cardDetail) => {
                  return {
                    ...cardDetail,
                    shipping: {
                      ...cardDetail.shipping,
                      address: event.target.value,
                    },
                  };
                });
                onCardDetailsChanged(updatedCardDetails);
              })}
            </Grid>
          )}
        {cardType == consts.CARD_TYPE_PLASTIC &&
          mailOption == consts.PLASTIC_TYPE_ME && (
            <Grid item xs={12} md={6}>
              {renderCityInput(cardDetails[0], "", validate, (event) => {
                let updatedCardDetails = [...cardDetails];
                updatedCardDetails = updatedCardDetails.map((cardDetail) => {
                  return {
                    ...cardDetail,
                    shipping: {
                      ...cardDetail.shipping,
                      city: event.target.value,
                    },
                  };
                });
                onCardDetailsChanged(updatedCardDetails);
              })}
            </Grid>
          )}
        {cardType == consts.CARD_TYPE_PLASTIC &&
          mailOption == consts.PLASTIC_TYPE_ME && (
            <Grid item xs={12} md={6}>
              {renderStateInput(cardDetails[0], "", validate, (event) => {
                let updatedCardDetails = [...cardDetails];
                updatedCardDetails = updatedCardDetails.map((cardDetail) => {
                  return {
                    ...cardDetail,
                    shipping: {
                      ...cardDetail.shipping,
                      state: event.target.value,
                    },
                  };
                });
                onCardDetailsChanged(updatedCardDetails);
              })}
            </Grid>
          )}
        {cardType == consts.CARD_TYPE_PLASTIC &&
          mailOption == consts.PLASTIC_TYPE_ME && (
            <Grid item xs={12} md={6}>
              {renderZipInput(cardDetails[0], "", validate, (event) => {
                let updatedCardDetails = [...cardDetails];
                updatedCardDetails = updatedCardDetails.map((cardDetail) => {
                  return {
                    ...cardDetail,
                    shipping: {
                      ...cardDetail.shipping,
                      zip: event.target.value,
                    },
                  };
                });
                onCardDetailsChanged(updatedCardDetails);
              })}
            </Grid>
          )}
      </Grid>
    );
  };

  return (
    <Grid item container xs={12} className={props.classes.cardmessagemain}>
      {props.cardDetails.length > 1 && renderSynchronizeOption()}
      {props.synchronize == consts.SYNCHRONIZE_YES &&
        renderGlobalInputs(
          props.cardDetails,
          props.validate,
          props.cardType,
          (cardDetails) => {
            props.onCardDetailsChanged(cardDetails);
          }
        )}
      {renderDelivery(
        props.cardDetails,
        props.cardType,
        props.mailOption,
        props.validate,
        (cardDetails) => {
          props.onCardDetailsChanged(cardDetails);
        }
      )}
      {renderRows(
        props.cardDetails,
        props.cardType,
        props.mailOption,
        props.synchronize == consts.SYNCHRONIZE_YES,
        props.validate,
        (cardDetails) => {
          props.onCardDetailsChanged(cardDetails);
        }
      )}
    </Grid>
  );
}
